import * as React from 'react';

import {ClosedLeadEmailAutomationEditor} from './closed-lead-email-list-editor';
import type {EmailListType} from './closed-lead-email-list-editor';

type Props = {
    isNew: boolean;
    stagesetId: string;
    parentId: string;
    entityId: string | null | undefined;
    type: EmailListType;
};

export class ClosedLeadConstantContactSubscriptionEditorWrapper extends React.PureComponent<Props> {
    render() {
        return <ClosedLeadEmailAutomationEditor {...this.props} type='CONSTANT_CONTACT' />;
    }
}
